import React from 'react';
import { LayoutHome } from './layout/LayoutHome';

export const HomeScreen = () => {

  return (
    <LayoutHome/>
  )
}
